import { makeStyles } from '@material-ui/core/styles';

interface AskAiButtonProps {
  onClick: () => void;
  /** Distance from the bottom of the viewport, in px. Default 30. */
  bottom?: number;
  /** Distance from the right of the viewport, in px. Default 30. */
  right?: number;
  /** Stacking order. Default 1200. */
  zIndex?: number;
  label?: string;
}

const useStyles = makeStyles(() => ({
  button: {
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '8px 20px 8px 8px',
    background: '#ffffff',
    border: 'none',
    borderRadius: 100,
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.14)',
    cursor: 'pointer',
    outline: 'none',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    '&:hover': {
      boxShadow: '0 6px 22px rgba(59, 91, 219, 0.28)',
      transform: 'translateY(-1px)',
    },
  },
  iconBadge: {
    width: 34,
    height: 34,
    borderRadius: '50%',
    background: '#E7ECFE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  label: {
    color: '#1A2B4A',
    fontSize: 15,
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
}));

const SparkleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2.5l1.9 5.1a3 3 0 0 0 1.75 1.75L20.75 11l-5.1 1.9a3 3 0 0 0-1.75 1.75L12 19.75l-1.9-5.1a3 3 0 0 0-1.75-1.75L3.25 11l5.1-1.9a3 3 0 0 0 1.75-1.75L12 2.5z"
      fill="#3B5BDB"
    />
    <path d="M19 3l.7 1.9L21.5 5.6l-1.8.7L19 8.2l-.7-1.9-1.8-.7 1.8-.7L19 3z" fill="#3B5BDB" />
  </svg>
);

export const AskAiButton = ({ onClick, bottom = 30, right = 30, zIndex = 1200, label = 'Ask AI' }: AskAiButtonProps) => {
  const classes = useStyles();
  return (
    <button
      type="button"
      className={classes.button}
      style={{ bottom, right, zIndex }}
      onClick={onClick}
      aria-label={label}
      title={label}
    >
      <span className={classes.iconBadge}>
        <SparkleIcon />
      </span>
      <span className={classes.label}>{label}</span>
    </button>
  );
};

export default AskAiButton;
